import React, { useEffect, useState } from 'react'

import { useProfessors, useStudents } from '../../../../context'
import { Student } from '../../../../types'
import { getProfileImage } from '../../../../utilFunctions/profileImage'
import { TableContainer } from '../../../lists/styles'

const ProfessorSharedProccess = ({
  professorName,
}: {
  professorName: string
}) => {
  const { studentsList } = useStudents()
  const { professorsList } = useProfessors()

  const [sharedProccess, setSharedProccess] = useState<Student[] | null>(null)

  useEffect(() => {
    if (studentsList) {
      const hasMoreThanOneProfessor = studentsList.filter(
        (student) =>
          student.professors.length > 1 &&
          student.professors.some((professor) => professor === professorName),
      )
      setSharedProccess(hasMoreThanOneProfessor)
    }
  }, [studentsList])

  const professors = (std: Student) => {
    return [...std.professors]
      .map((name) => {
        const isActive =
          professorsList?.some(
            (professor) => `${professor.name} ${professor.lastname}` === name,
          ) ?? false
        return { name, isActive }
      })
      .sort((a, b) => {
        if (a.isActive && !b.isActive) return -1
        if (!a.isActive && b.isActive) return 1
        return 0
      })
      .map(({ name, isActive }, i) => (
        <span
          key={i}
          className={!isActive ? 'inactive' : undefined}
          style={{ textTransform: 'capitalize' }}
        >
          {name}
        </span>
      ))
  }

  return (
    <TableContainer>
      {sharedProccess &&
        sharedProccess.map((std, i) => {
          return (
            <div
              key={i}
              className="t-row"
              style={{ justifyContent: 'space-between' }}
            >
              <div className="t-student with-image">
                <div
                  className="profile-image"
                  style={{
                    backgroundImage: `url(${getProfileImage(std.image)})`,
                  }}
                ></div>
                {std.name} {std.lastname}
              </div>
              <div
                className="t-professors"
                style={{
                  width: '50%',
                  flex: 'none',
                  gap: '20px',
                  justifyContent: 'flex-start',
                }}
              >
                Profesores:
                {professors(std)}
              </div>
            </div>
          )
        })}
    </TableContainer>
  )
}

export default ProfessorSharedProccess
